import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import view from '@toast-view-current';
import type { ToastType } from './types';

export const showToastNotification = (message: string, type: ToastType = 'info') => {
  const { ToastItem } = view;
  toast(<ToastItem type={type} message={message} />, view.toastOptions(type));
};
